// extracted by mini-css-extract-plugin
module.exports =  {"container":"da51a739f7--container--sDwIj","side":"da51a739f7--side--m7mv9","slider-item":"da51a739f7--slider-item--Ub59b","callback":"da51a739f7--callback--dkUS3"};